import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FunnelPlotTwoToneSvg from "@ant-design/icons-svg/es/asn/FunnelPlotTwoTone";
import AntdIcon from "../components/AntdIcon";
var FunnelPlotTwoTone = function FunnelPlotTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FunnelPlotTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FunnelPlotTwoTone.displayName = 'FunnelPlotTwoTone';
}
export default /*#__PURE__*/React.forwardRef(FunnelPlotTwoTone);